import { useMemo, useState } from 'react';
import { newsList } from '@/mocks/news';
import ArticleCard from '@/components/feature/ArticleCard';
import Pagination from '@/components/base/Pagination';
import PageHeader from '@/components/feature/PageHeader';
import EmptyState from '@/components/feature/EmptyState';
import NewsFilter from '@/pages/news/components/NewsFilter';
import { usePageMeta } from '@/hooks/usePageMeta';

const PAGE_SIZE = 6;

const baseNews = newsList.filter((a) => a.type === 'news');
const categories = ['全部', ...Array.from(new Set(baseNews.map((a) => a.category)))];

const sortOptions = [
  { value: 'latest', label: '按发布时间' },
  { value: 'hot', label: '按热门程度' },
];

export default function News() {
  usePageMeta({
    title: '原神最新资讯 - 原神游戏资讯平台',
    description:
      '原神最新资讯频道汇总版本更新、活动情报与玩法解析，支持按分类筛选与热门排序，帮助你快速掌握提瓦特的最新动态。',
    keywords: '原神资讯,原神新闻,版本更新,活动情报,原神攻略',
  });

  const [category, setCategory] = useState('全部');
  const [sort, setSort] = useState('latest');
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    const list = baseNews.filter((a) => category === '全部' || a.category === category);
    return [...list].sort((a, b) => {
      if (sort === 'hot') return b.views - a.views;
      return a.date < b.date ? 1 : -1;
    });
  }, [category, sort]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const pageItems = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  const handleCategory = (value: string) => {
    setCategory(value);
    setPage(1);
  };
  const handleSort = (value: string) => {
    setSort(value);
    setPage(1);
  };
  const reset = () => {
    setCategory('全部');
    setSort('latest');
    setPage(1);
  };

  return (
    <div>
      <PageHeader
        crumbs={[{ label: '首页', to: '/' }, { label: '资讯分类' }]}
        icon="ri-newspaper-line"
        title="最新游戏资讯"
        description="浏览全部原神相关资讯，支持按分类筛选与热门排序，点击卡片查看完整内容。"
      />

      <div className="container-page py-8 md:py-12">
        <NewsFilter
          categories={categories}
          category={category}
          onCategory={handleCategory}
          sort={sort}
          onSort={handleSort}
          sortOptions={sortOptions}
          total={filtered.length}
        />

        <div className="mt-6">
          {pageItems.length > 0 ? (
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {pageItems.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <EmptyState
              icon="ri-search-eye-line"
              title="没有找到匹配的资讯"
              description="当前筛选条件下暂无内容，试试切换分类或重置筛选条件。"
              actionLabel="重置筛选"
              onAction={reset}
            />
          )}
        </div>

        {filtered.length > 0 && (
          <div className="mt-8">
            <Pagination page={currentPage} totalPages={totalPages} onChange={setPage} />
          </div>
        )}
      </div>
    </div>
  );
}